import React from 'react';

const FourTrack = () => {
    return (
      <React.Fragment>
        <div className="btn__base r3c3">
          <div className="btn">
            <div className="tape">
              <div className="tape__circle"></div>
              <div className="tape__line"></div>
              <div className="tape__circle__right"></div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };
  
export default FourTrack;